import { BatteryDto } from "app/ApiClient";
import { LoadingState } from "types";

export type BatteryState = {
  loading: LoadingState;
  battery: Nullable<BatteryDto>;
  error: Nullable<{ value: string; message: string }>;
};
export const initialBatteryState: BatteryState = {
  loading: LoadingState.idle,
  battery: undefined,
  error: undefined,
};
